import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function OpeningLead() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 10
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8
      }
    }
  };
  return <section className="w-full bg-[#faf7f2] py-20 px-4" data-id="element-259">
      <div className="max-w-[680px] mx-auto" data-id="element-260">
        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-8 text-[#2d2926]" data-id="element-261">
          <motion.p variants={item} className="font-mono text-sm tracking-widest text-[#5b8a7a] uppercase mb-8" data-id="element-262">
            Son las 2:07 AM.
          </motion.p>

          <motion.p variants={item} className="font-serif text-2xl md:text-3xl leading-relaxed text-[#0f172a]" data-id="element-263">
            Tu bebé despierta otra vez.
          </motion.p>

          <motion.p variants={item} className="text-lg md:text-xl leading-[1.8] font-light" data-id="element-264">
            Tú ya estabas medio dormida, pero el primer llanto te atraviesa como
            una alarma. Te sientas, lo tomas, miras el pañal, dudas si es
            hambre, si es gases, si está frío, si lo acuestas se despierta, si
            lo cargas nunca termina…
          </motion.p>

          <motion.p variants={item} className="text-lg md:text-xl leading-[1.8] font-light" data-id="element-265">
            Y en menos de 60 segundos estás haciendo lo que todas hacemos cuando
            estamos rotas de sueño:
          </motion.p>

          <motion.p variants={item} className="font-serif text-2xl md:text-3xl italic text-[#e8856c] text-center py-4" data-id="element-266">
            improvisar.
          </motion.p>

          <motion.p variants={item} className="text-lg md:text-xl leading-[1.8] font-light" data-id="element-267">
            No porque no lo ames.
            <br data-id="element-268" />
            No porque “no seas buena mamá”.
          </motion.p>

          <motion.p variants={item} className="text-lg md:text-xl leading-[1.8] font-light" data-id="element-269">
            Sino porque nadie te dio lo único que se necesita en ese momento:
          </motion.p>

          <motion.p variants={item} className="font-serif text-3xl md:text-4xl font-bold text-[#0f172a] text-center pt-4" data-id="element-270">
            un orden.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}